// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--3rc3v","next":"button-module--next--19JV1","back":"button-module--back--3vSEh"};